import * as React from 'react'
import {ChangeEvent, Component, ReactElement} from 'react'
import {Box, Collapse} from '@mui/material'
import {Nullable} from '../../../../../app/TypeHelpers';
import {NatSharer} from './NatGuestOwnershipTransferNewMemberInterface';
import {
    ItemHeading,
    ListGridContainer,
    WideWhiteArea
} from '../../../applications/common/resident/NatResidentApplicationsCommon';
import NatGuestOwnershipTransfersDetailFormItem from '../../common/NatGuestOwnershipTransfersDetailFormItem';
import {PPTextFieldForResident} from '../../../../../components/shared/forms/resident/PPTextFieldForResident';
import {
    FlexContainer,
    FullWidthColumnFlexContainer,
    FullWidthRowFlexContainer,
    LeftRowFlexContainer,
    RightColumnFlexContainer
} from '../../../../../styledComponents/FlexComponents';
import {BlockSpacer, currentMedia,} from '../../../../../styledComponents/ResponsiveConvenience';
import {Colors, FontSize, FontWeights} from '../../../../../styledComponents/Constants';
import {TxtBold} from '../../../../../styledComponents/ContentsArea';
import {TransitionGroup} from 'react-transition-group';
import {HKConstants} from '../../../../../HKConstants';
import {AddCircle, Clear} from '@mui/icons-material';
import styled from 'styled-components';
import {UnstyledLinkStyledButton} from '../../../../../styledComponents/Button';
import PPRadioGroupForGuest from '../../../../../components/shared/forms/guest/PPRadioGroupForGuest';
import {RESIDENT_PLACE} from '../../../../../CodeMaster';
import {NatPutOwnershipTransferNewMemberOutlineRequest,} from '../../repository/NatPutNewMemberRequest';
import EventEmitterExGuest from '../../../../../components/shared/pageBaseComponents/EventEmitterExGuest';
import {autoKanaOnUpdate, toFullWidthNumber} from '../../../../common/util/Natutil';
import {DisplayItemInputTitleRequiredNoMargin} from '../../../../../styledComponents/DisplayItem';
import {
    GuestLoginInfoSessionStorageKey,
    NatGuestLoginInfoSessionStorageHelper
} from '../../../../common/authentication/NatGuestLoginInfoSessionStorageHelper';
import {GuestApplyButton} from '../../common/NatOwnershipTransfersCommon'

interface Props {
    condominiumCd: string
    applyId: string
    eventEmitter: EventEmitterExGuest

    familyName: Nullable<string>
    firstName: Nullable<string>
    familyNameKana: Nullable<string>
    firstNameKana: Nullable<string>
    mailAddress: Nullable<string>
    mailAddressConfirm: Nullable<string>
    sharerList: NatSharer[]
    residentPlace: Nullable<string>

    submitButtonLabel: string
    onClickApplyConfirmButton: (request: NatPutOwnershipTransferNewMemberOutlineRequest) => Promise<void>
}

interface State {
    familyName: string
    firstName: string
    familyNameKana: string
    firstNameKana: string
    mailAddress: string
    mailAddressConfirm: string
    sharerList: Sharer[]
    residentPlace: string

    applyButtonDisabled: boolean
    isLoadCompleted: boolean
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
}

interface Sharer extends NatSharer {
    key: number
    index: number
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
}

export default class NatGuestNewMemberOutlinePageForm extends Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            familyName: '',
            firstName: '',
            familyNameKana: '',
            firstNameKana: '',
            mailAddress: '',
            mailAddressConfirm: '',
            sharerList: [],
            residentPlace: '',
            applyButtonDisabled: true,
            isLoadCompleted: false,
            convertFamilyNameKana: '',
            preFamilyNameKana: '',
            convertFirstNameKana: '',
            preFirstNameKana: '',
        }

        this.handleChangeText = this.handleChangeText.bind(this)
        this.handleChangeFamilyName = this.handleChangeFamilyName.bind(this)
        this.handleChangeFirstName = this.handleChangeFirstName.bind(this)
        this.handleChangeSharerFamilyName = this.handleChangeSharerFamilyName.bind(this)
        this.handleChangeSharerFirstName = this.handleChangeSharerFirstName.bind(this)
        this.handleChangeSharerNameKana = this.handleChangeSharerNameKana.bind(this)
        this.handleChangeResidentPlace = this.handleChangeResidentPlace.bind(this)
        this.onClickAddSharerButton = this.onClickAddSharerButton.bind(this)
        this.onClickDeleteSharerButton = this.onClickDeleteSharerButton.bind(this)
        this.onClickApplyConfirmButton = this.onClickApplyConfirmButton.bind(this)
        this.onCompositionStartFamilyName = this.onCompositionStartFamilyName.bind(this)
        this.onCompositionUpdateFamilyName = this.onCompositionUpdateFamilyName.bind(this)
        this.onCompositionStartFirstName = this.onCompositionStartFirstName.bind(this)
        this.onCompositionUpdateFirstName = this.onCompositionUpdateFirstName.bind(this)
        this.onCompositionStartSharerFamilyName = this.onCompositionStartSharerFamilyName.bind(this)
        this.onCompositionUpdateSharerFamilyName = this.onCompositionUpdateSharerFamilyName.bind(this)
        this.onCompositionStartSharerFirstName = this.onCompositionStartSharerFirstName.bind(this)
        this.onCompositionUpdateSharerFirstName = this.onCompositionUpdateSharerFirstName.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const familyName = this.props.familyName ?? this.state.familyName
            const firstName = this.props.firstName ?? this.state.firstName
            const familyNameKana = this.props.familyNameKana ?? this.state.familyNameKana
            const mailAddress = this.props.mailAddress ?? this.state.mailAddress
            const firstNameKana = this.props.firstNameKana ?? this.state.firstNameKana
            const mailAddressConfirm = this.props.mailAddressConfirm ?? this.state.mailAddressConfirm
            const sharerList = this.props.sharerList ?? this.state.sharerList
            const residentPlace = this.props.residentPlace ?? this.state.residentPlace


            const keyAddSharerList: Sharer[] = sharerList.map((sharer, index) => {
                return {
                    ...sharer,
                    key: Math.random(),
                    index: index,
                    convertFamilyNameKana: '',
                    preFamilyNameKana: '',
                    convertFirstNameKana: '',
                    preFirstNameKana: '',
                }
            })

            this.setState({
                familyName: familyName,
                firstName: firstName,
                familyNameKana: familyNameKana,
                firstNameKana: firstNameKana,
                mailAddress: mailAddress,
                mailAddressConfirm: mailAddressConfirm,
                sharerList: keyAddSharerList,
                residentPlace: residentPlace
            }, () => {
                this.updateApplyConfirmButtonDisabled()
            })
        } finally {
            this.setState({isLoadCompleted: true})
            this.props.eventEmitter.closeLoading()
        }
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeSharerNameKana(event: ChangeEvent<HTMLInputElement>): void {
        const {sharerList} = this.state
        const key = event.target.name.substring(event.target.name.indexOf('.')).slice(1) as keyof State
        const value: string = event.target.value
        const index = Number(event.target.dataset.sharerindex)
        const sharer = {...sharerList[index], ...{[key]: value}}
        sharerList[index] = sharer

        this.setState({sharerList: sharerList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            familyName: event.target.value,
            familyNameKana: event.target.value ? this.state.convertFamilyNameKana : '',
        })
    }

    handleChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            firstName: event.target.value,
            firstNameKana: event.target.value ? this.state.convertFirstNameKana : '',
        })
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            familyName, firstName, familyNameKana, firstNameKana,
            mailAddress, mailAddressConfirm, sharerList, residentPlace
        } = this.state

        let applyButtonDisabled = false

        if (!familyName || !firstName || !familyNameKana || !firstNameKana ||
            !mailAddress || !mailAddressConfirm || !sharerList || !residentPlace) {
            applyButtonDisabled = true
        } else {
            sharerList.map(sharer => {
                if (!sharer.sharerFamilyName || !sharer.sharerFirstName ||
                    !sharer.sharerFamilyNameKana || !sharer.sharerFirstNameKana) {
                    applyButtonDisabled = true
                }
            })
        }

        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    handleChangeSharerFamilyName(event: ChangeEvent<HTMLInputElement>): void {
        const {sharerList} = this.state
        const index = Number(event.target.dataset.sharerindex)
        sharerList[index].sharerFamilyName = event.target.value
        if (sharerList[index].sharerFamilyName) {
            sharerList[index].sharerFamilyNameKana = this.state.sharerList[index].convertFamilyNameKana
        } else {
            sharerList[index].sharerFamilyNameKana = ''
        }

        this.setState({sharerList: sharerList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeSharerFirstName(event: ChangeEvent<HTMLInputElement>): void {
        const {sharerList} = this.state
        const index = Number(event.target.dataset.sharerindex)
        sharerList[index].sharerFirstName = event.target.value
        if (sharerList[index].sharerFirstName) {
            sharerList[index].sharerFirstNameKana = this.state.sharerList[index].convertFirstNameKana
        } else {
            sharerList[index].sharerFirstNameKana = ''
        }

        this.setState({sharerList: sharerList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeResidentPlace(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            residentPlace: event.target.value
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    onCompositionStartFamilyName(): void {
        this.setState({
            convertFamilyNameKana: '',
            preFamilyNameKana: this.state.familyNameKana ?? '',
        })
    }

    onCompositionUpdateFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFamilyNameKana: this.state.preFamilyNameKana + kana})
        })
    }

    onCompositionStartFirstName(): void {
        this.setState({
            convertFirstNameKana: '',
            preFirstNameKana: this.state.firstNameKana ?? '',
        })
    }

    onCompositionUpdateFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFirstNameKana: this.state.preFirstNameKana + kana})
        })
    }

    onCompositionStartSharerFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        const {sharerList} = this.state
        const index = Number(event.currentTarget.dataset.sharerindex)
        sharerList[index].convertFamilyNameKana = ''
        sharerList[index].preFamilyNameKana = sharerList[index].sharerFamilyNameKana ?? ''
        this.setState({sharerList: sharerList})
    }

    onCompositionUpdateSharerFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        const {sharerList} = this.state
        const index = Number(event.currentTarget.dataset.sharerindex)
        autoKanaOnUpdate(event.data, (kana) => {
            sharerList[index].convertFamilyNameKana = sharerList[index].preFamilyNameKana + kana
            this.setState({sharerList: sharerList})
        })
    }

    onCompositionStartSharerFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        const {sharerList} = this.state
        const index = Number(event.currentTarget.dataset.sharerindex)
        sharerList[index].convertFirstNameKana = ''
        sharerList[index].preFirstNameKana = sharerList[index].sharerFirstNameKana ?? ''
        this.setState({sharerList: sharerList})
    }

    onCompositionUpdateSharerFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        const {sharerList} = this.state
        const index = Number(event.currentTarget.dataset.sharerindex)
        autoKanaOnUpdate(event.data, (kana) => {
            sharerList[index].convertFirstNameKana = sharerList[index].preFirstNameKana + kana
            this.setState({sharerList: sharerList})
        })
    }

    onClickAddSharerButton(): void {
        const {sharerList} = this.state

        sharerList.push(
            {
                index: sharerList.length,
                sharerFamilyName: '',
                sharerFirstName: '',
                sharerFamilyNameKana: '',
                sharerFirstNameKana: '',
                key: Math.random(),
                convertFamilyNameKana: '',
                preFamilyNameKana: '',
                convertFirstNameKana: '',
                preFirstNameKana: '',
            }
        )
        this.setState({sharerList: sharerList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    onClickDeleteSharerButton(index: number): void {
        const {sharerList} = this.state
        const updatedSharerList: Sharer[] = []

        sharerList.map((sharer) => {
            const tmpSharer: Sharer = sharer
            if (sharer.index !== index) {
                tmpSharer.index = updatedSharerList.length
                updatedSharerList.push(tmpSharer)
            }
        })

        this.setState({sharerList: updatedSharerList}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    async onClickApplyConfirmButton(): Promise<void> {
        const {applyId} = this.props
        const {
            familyName,
            firstName,
            familyNameKana,
            firstNameKana,
            mailAddress,
            mailAddressConfirm,
            sharerList,
            residentPlace
        } = this.state

        const sharerListRequest:NatSharer[] = sharerList.map(sharer => {
            return {
                sharerFamilyName: sharer.sharerFamilyName,
                sharerFamilyNameKana: sharer.sharerFamilyNameKana,
                sharerFirstName: sharer.sharerFirstName,
                sharerFirstNameKana: sharer.sharerFirstNameKana
            }
        })

        let request: Nullable<NatPutOwnershipTransferNewMemberOutlineRequest> = null

        request = {
            applyId: applyId,
            familyName: familyName,
            firstName: firstName,
            familyNameKana: familyNameKana,
            firstNameKana: firstNameKana,
            mailAddress: mailAddress,
            mailAddressConfirm: mailAddressConfirm,
            sharer: sharerListRequest,
            residentPlace: residentPlace
        }

        if (!request) {
            return
        }
        await this.props.onClickApplyConfirmButton(request)
    }

    renderNewMemberInfo(): ReactElement {
        const {familyName, firstName, familyNameKana,
            firstNameKana, mailAddress, mailAddressConfirm} = this.state

        return (
            <>
                <ItemHeading>
                    新組合員情報
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'familyName',
                                        id: 'familyName',
                                        maxLength: 10,
                                        value: familyName,
                                        onInput: this.handleChangeFamilyName,
                                        onChange: this.handleChangeFamilyName,
                                        onCompositionStart: this.onCompositionStartFamilyName,
                                        onCompositionUpdate: this.onCompositionUpdateFamilyName,
                                        placeholder: '例：新組合員'
                                    }}
                                    onChange={this.handleChangeFamilyName}
                                    eventKeys={['familyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'firstName',
                                        id: 'firstName',
                                        maxLength: 10,
                                        value: firstName,
                                        onInput: this.handleChangeFirstName,
                                        onChange: this.handleChangeFirstName,
                                        onCompositionStart: this.onCompositionStartFirstName,
                                        onCompositionUpdate: this.onCompositionUpdateFirstName,
                                        placeholder: '例：花子'
                                    }}
                                    onChange={this.handleChangeFirstName}
                                    eventKeys={['firstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <Box fontSize={FontSize.Middle}>
                        <div>※区分所有者の氏名を入力してください</div>
                    </Box>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'氏名カナ'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'familyNameKana',
                                        id: 'familyNameKana',
                                        maxLength: 20,
                                        value: familyNameKana,
                                        onChange: this.handleChangeText,
                                        placeholder: '例：シンクミアイイン'
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['familyNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'firstNameKana',
                                        id: 'firstNameKana',
                                        maxLength: 20,
                                        value: firstNameKana,
                                        placeholder: '例：ハナコ'
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['firstNameKana']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'メールアドレス'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'mailAddress',
                                        maxLength: 100,
                                        value: mailAddress,
                                        onChange: this.handleChangeText,
                                        placeholder: '例：mail@example.com'
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['mailAddress']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={<span>メールアドレス<BreakPcOnly/>（確認用）</span>}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'mailAddressConfirm',
                                        maxLength: 100,
                                        value: mailAddressConfirm,
                                        onChange: this.handleChangeText,
                                        placeholder: '例：mail@example.com'
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['mailAddressConfirm']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <Box fontSize={FontSize.Small}>
                        <TxtBold>【注意事項】</TxtBold>
                        <ListGridContainer>
                            <div>・</div>
                            <div>メールが届かない場合は、ご契約のプロバイダやメールソフトの設定などにより、受信ができない可能性がございます。</div>
                            <div>・</div>
                            <div>迷惑メールの対策で、ドメイン受信設定を行っている場合は、
                                「@suteki.haseko.jp」「@haseko.co.jp」を受信設定してください。設定方法はご契約のプロバイダのWebサイトをご確認ください。</div>
                            <div>・</div>
                            <div>yahooメール/gmail等のフリーメールアドレスでもご登録いただけます。
                                スマートフォンをご利用のお客様でも、SMSにて受信するメールアドレスをご利用の方は、確認メールが正しく表示されず、ご登録いただけませんので、ご注意ください。</div>
                        </ListGridContainer>
                    </Box>
                    <Box height={'15px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderSharerListForm(): ReactElement {
        const {sharerList} = this.state

        return (
            <>
                <ItemHeading>
                    共有者情報（共有名義の場合）
                </ItemHeading>
                <SharerListArea>
                    <TransitionGroup>
                        {sharerList.map(
                            (sharer, key) => {
                                return (<Collapse key={sharer.key}>
                                    <Box>{sharer.index === 0 ?
                                        <Box height={'15px'}/> : <Box height={'20px'}/>}
                                        {this.renderSharerForm(key, sharer)}</Box>
                                </Collapse>)
                            })}
                    </TransitionGroup>
                    {(HKConstants.VGS.OST.SHARER_ADD_LIMIT > sharerList.length)
                        ? <AddButton onClick={this.onClickAddSharerButton}>
                            <LeftRowFlexContainer>
                                <AddCircle style={circleIconStyle}/>
                                {`共有者を追加する`}
                            </LeftRowFlexContainer>
                        </AddButton>
                        : <Box height={'20px'}/>
                    }
                </SharerListArea>
            </>
        )
    }

    renderSharerForm(
        key: number,
        sharer: Sharer
    ): ReactElement {
        const  {index, sharerFamilyName, sharerFirstName,
            sharerFamilyNameKana, sharerFirstNameKana} = sharer

        return (
            <SharerArea>
                <SharerItemHeading>
                    <FullWidthRowFlexContainer>
                        <LeftRowFlexContainer>
                            {`共有者${toFullWidthNumber(index + 1)}`}
                        </LeftRowFlexContainer>
                        <RightColumnFlexContainer>
                            <ClearButton onClick={() => {
                                this.onClickDeleteSharerButton(index)
                            }}>
                                <LeftRowFlexContainer>
                                    <Clear style={clearIconStyle}/>
                                    取消
                                </LeftRowFlexContainer>
                            </ClearButton>
                        </RightColumnFlexContainer>
                    </FullWidthRowFlexContainer>
                </SharerItemHeading>
                <Box p={'0 10px'}>
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: `sharer[${index}].sharerFamilyName`,
                                        id: `sharer[${index}].sharerFamilyName`,
                                        maxLength: 10,
                                        value: sharerFamilyName,
                                        onInput: this.handleChangeSharerFamilyName,
                                        onChange: this.handleChangeSharerFamilyName,
                                        onCompositionStart: this.onCompositionStartSharerFamilyName,
                                        onCompositionUpdate: this.onCompositionUpdateSharerFamilyName,
                                        placeholder: '例：素敵'
                                    }}
                                    data-sharerindex={key}
                                    onChange={this.handleChangeSharerFamilyName}
                                    eventKeys={[`sharer[${index}].sharerFamilyName`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: `sharer[${index}].sharerFirstName`,
                                        id: `sharer[${index}].sharerFirstName`,
                                        maxLength: 10,
                                        value: sharerFirstName,
                                        onInput: this.handleChangeSharerFirstName,
                                        onChange: this.handleChangeSharerFirstName,
                                        onCompositionStart: this.onCompositionStartSharerFirstName,
                                        onCompositionUpdate: this.onCompositionUpdateSharerFirstName,
                                        placeholder: '例：太郎'
                                    }}
                                    data-sharerindex={key}
                                    onChange={this.handleChangeSharerFirstName}
                                    eventKeys={[`sharer[${index}].sharerFirstName`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                    <NatGuestOwnershipTransfersDetailFormItem
                        title={'氏名カナ'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: `sharer[${index}].sharerFamilyNameKana`,
                                        id: `sharer[${index}].sharerFamilyNameKana`,
                                        maxLength: 20,
                                        value: sharerFamilyNameKana,
                                        onChange: this.handleChangeSharerNameKana,
                                        placeholder: '例：ステキ'
                                    }}
                                    data-sharerindex={key}
                                    onChange={this.handleChangeSharerNameKana}
                                    eventKeys={[`sharer[${index}].sharerFamilyNameKana`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: `sharer[${index}].sharerFirstNameKana`,
                                        id: `sharer[${index}].sharerFirstNameKana`,
                                        maxLength: 20,
                                        value: sharerFirstNameKana,
                                        onChange: this.handleChangeSharerNameKana,
                                        placeholder: '例：タロウ'
                                    }}
                                    data-sharerindex={key}
                                    onChange={this.handleChangeSharerNameKana}
                                    eventKeys={[`sharer[${index}].sharerFirstNameKana`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                </Box>
            </SharerArea>
        )
    }

    renderResidentPlace(): ReactElement {
        const {residentPlace} = this.state

        return (
            <>
                <ItemHeading>
                    居住先
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <DisplayItemInputTitleRequiredNoMargin>
                        この部屋に住む
                    </DisplayItemInputTitleRequiredNoMargin>
                    <Box height={'10px'}/>
                    <PPRadioGroupForGuest
                        data={RESIDENT_PLACE.values()}
                        selectValue={residentPlace}
                        onChange={this.handleChangeResidentPlace}
                        eventKeys={['residentPlace']}
                        eventEmitter={this.props.eventEmitter}
                    />
                    <Box height={'20px'}/>
                    <Box fontSize={FontSize.Middle}>
                        <div>※海外へお住まいの方は、国内に代理の連絡先が必要となります。</div>
                    </Box>
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return <></>
        }

        const {submitButtonLabel} = this.props
        const {applyButtonDisabled} = this.state

        const applicantRoom = NatGuestLoginInfoSessionStorageHelper
                .getStringItemOrNull(GuestLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
            NatGuestLoginInfoSessionStorageHelper
                .getStringItemOrNull(GuestLoginInfoSessionStorageKey.SELECTED_RIDGE_NAME) + ' ' +
            convertToRoomNumber(
                NatGuestLoginInfoSessionStorageHelper
                    .getStringItemOrNull(GuestLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER)
            )

        return (
            <>
                <ItemHeading>
                    対象住戸
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    {applicantRoom}
                    <Box height={'20px'}/>
                </WideWhiteArea>
                <Box height={'15px'}/>
                {this.renderNewMemberInfo()}
                <Box height={'15px'}/>
                {this.renderSharerListForm()}
                <Box height={'15px'}/>
                {this.renderResidentPlace()}
                <Box height={'20px'}/>
                <GuestApplyButton disabled={applyButtonDisabled} onClick={this.onClickApplyConfirmButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            {submitButtonLabel}
                        </div>
                    </FullWidthColumnFlexContainer>
                </GuestApplyButton>
            </>
        )
    }
}

const SharerListArea = styled(WideWhiteArea)`
 padding: 0 5px;
`

const SharerArea = styled.div`
  border: 1px solid rgba(0, 112, 176, 0.5);
`

const SharerItemHeading = styled.div`
  background-color: ${Colors.LightGreen};
  padding: 10px 15px;
  box-sizing: border-box;
  overflow: hidden;
`

const AddButton = styled(UnstyledLinkStyledButton)`
  padding: 20px 20px 20px 0;
  color: ${Colors.GuestPrimary};
  font-weight: ${FontWeights.Bold};
  line-height: 24px;
`

const ClearButton = styled(UnstyledLinkStyledButton)`
  color: ${Colors.Alert};
  line-height: 24px;
`

const circleIconStyle = {
    fontSize: FontSize.Big,
    color: Colors.GuestPrimary,
    marginRight: '3px',
}

const clearIconStyle = {
    fontSize: FontSize.Big,
    color: Colors.Alert,
    marginRight: '3px',
}

const BreakPcOnly = styled('br')`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`

export function convertToRoomNumber(roomNumber: Nullable<string>): Nullable<string> {
    if (!roomNumber) {
        return roomNumber
    }

    if (roomNumber.match(/^0+\d{3}/)) {
        return roomNumber.slice(1);
    }

    return roomNumber;
}
